import { z } from "zod";

// const phoneRegex = /^(?:\+?9665\d{8}|\+?201[0125]\d{8})$/;

const phoneRegex = /^\+?[1-9]\d{6,14}$/

export const signupSchema = (type) =>
  z
    .object({
      first_name: z
        .string()
        .trim()
        .min(1, "الاسم الأول مطلوب")
        .min(3, "يجب أن يكون الاسم الأول 3 أحرف على الأقل"),
      last_name: z
        .string()
        .trim()
        .min(1, "الاسم الثاني مطلوب")
        .min(3, "يجب أن يكون الاسم الثاني 3 أحرف على الأقل"),
      phone: z
        .string()
        .trim()
        .min(1, "رقم الهاتف مطلوب")
        .regex(phoneRegex, "رقم الهاتف غير صحيح، يجب أن يكون رقمًا صحيحًا مع مفتاح الدولة"),
      password: z
        .string()
        .trim()
        .min(8, "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل")
        .regex(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
          "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم وحرف خاص على الأقل"
        ),
      confirmPassword: z.string().trim().min(1, "تأكيد كلمة المرور مطلوب"),
      ...(type === "lawyer"
        ? {
          addresses: z
            .array(
              z.object({
                location: z.string().min(1, "العنوان مطلوب"),
                city: z.string().min(1, "المدينة مطلوبة"),
                area: z.string().min(1, "المنطقة مطلوبة"),
              })
            )
            .min(1, "يجب إضافة عنوان واحد على الأقل"),
        }
        : {}),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: "كلمتا المرور غير متطابقتين",
      path: ["confirmPassword"],
    });

// Usage Example
export const lawyerSchema = signupSchema("lawyer");
export const customerSchema = signupSchema("customer");

export const userLoginSchema = z.object({
  phone: z
    .string()
    .trim()
    .min(1, "رقم الهاتف مطلوب")
    .regex(phoneRegex, "رقم الهاتف غير صحيح، يجب أن يكون رقمًا صحيحًا مع مفتاح الدولة"),
  password: z.string().trim().min(6, "كلمة المرور قصيرة، يجب أن تكون 6 أحرف على الأقل"),
});

export const userLoginPhoneSchema = z.object({
  phone: z
    .string()
    .trim()
    .min(1, "رقم الهاتف مطلوب")
    .regex(phoneRegex, "رقم الهاتف غير صحيح، يجب أن يكون رقمًا صحيحًا مع مفتاح الدولة"),
});

export const userOtpSchema = z.object({
  otp: z.string().trim().min(1, "رمز التحقق مطلوب")
    .refine(val => val.length === 4 || val.length === 6, { message: "الرمز يجب أن يكون 4 أو 6 أرقام بالضبط" })
});

export const userResetPasswordSchema = z.object({
  phone: z
    .string()
    .trim()
    .min(1, "رقم الهاتف مطلوب")
    .regex(phoneRegex, "رقم الهاتف غير صحيح، يجب أن يكون رقمًا صحيحًا مع مفتاح الدولة"),
});

export const userNewPasswordSchema = z
  .object({
    password: z
      .string()
      .trim()
      .min(8, "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل")
      .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
        "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم وحرف خاص على الأقل"
      ),
    confirmPassword: z.string().trim().min(1, "تأكيد كلمة المرور مطلوب"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "كلمة المرور غير متطابقة",
  });


export const completeAccount = z.object({
  profileImage: z.instanceof(globalThis.File, { message: "صورة البروفايل مطلوبة" }),
  cardImage: z.instanceof(globalThis.File, { message: "صورة كارنيه النقابة مطلوبة" }),
  idImage: z.instanceof(globalThis.File, { message: "صورة البطاقة مطلوبة" }),
  specialty: z.array(z.string()).nonempty({ message: "يجب اختيار التخصص" }), // Updated for multi-select
  subSpecialty: z.array(z.string()).nonempty({ message: "يجب اختيار التخصص الفرعي" }), // Updated for multi-select
  bio: z.string().min(1, "الملخص مطلوب"),
});

export const orderServiceSchema = z.object({
  note: z.string().min(1, "وصف الخدمة مطلوب"),
});



export const changePasswordSchema = z
  .object({
    currentPassword: z.string().trim().min(1, "كلمة المرور الحالية مطلوبة"),
    newPassword: z
      .string()
      .trim()
      .min(6, "كلمة المرور يجب أن تحتوي على 6 أحرف على الأقل")
      .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,}$/,
        "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم وحرف خاص على الأقل"
      ),
    confirmPassword: z.string().trim().min(6, "تأكيد كلمة المرور مطلوب"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "كلمة المرور غير متطابقة",
  });


export const changeUserInfoSchema = z.object({
  firstName: z.string().min(2, "الاسم الأول مطلوب"),
  lastName: z.string().min(2, "الاسم الثاني مطلوب"),
  phone: z
    .string()
    .trim()
    .min(1, "رقم الهاتف مطلوب")
    .regex(phoneRegex, "رقم الهاتف غير صحيح، يجب أن يكون رقمًا صحيحًا مع مفتاح الدولة"),
});

export const ratingSchema = z.object({
  rating: z.number().min(1, "الرجاء اختيار تقييم").max(5, "التقييم يجب أن يكون من 1 إلى 5"),
  comment: z.string().min(1, "الرجاء كتابة تعليق").max(500, "التعليق يجب أن لا يتجاوز 500 حرف"),
});


